// Module
var code = "<p><a href=\"/manage/resources/glossary#federal-family-education-loan-program-ffelp\">What is a FFELP Loan?</a></p> ";
// Exports
export default code;